//@ts-nocheck
/**
 * This is the BookingEmptyState component.
 *
 * @namespace Pages
 */

import { Box, Typography } from '@mui/material';
import { XGModal } from 'xg-cl';
import { parseISODateWithoutOffset } from '../../utils/dateUtility';
import { format, add } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getOperatorContactLink } from '../../utils/operatorContact';
import './BookingEmptyState.css';

const BookingEmptyState = ({ isOpenModal, updateIsOpen }) => {
  const { t } = useTranslation(['trip', 'common', 'bookings']);

  const tripData = useSelector((state) => state.booking?.trip);
  const operatorContact = {
    ...(tripData?.operatorContact || {}),
    email: tripData?.operatorContact?.email || tripData?.operatorEmail
  };
  const duration = tripData?.duration || 0;
  const tripName = tripData?.tripname || '';
  const tripImage = tripData?.tripimage?.[0]?.imageurl || null;
  const startDate = tripData?.startdate
    ? parseISODateWithoutOffset(tripData?.startdate)
    : null;
  const endDate = startDate && add(new Date(startDate), { days: duration - 1 });

  // Format dates
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      return format(
        new Date(dateString),
        t('common:dateFormat') || 'dd MMM yyyy'
      );
    } catch {
      return '';
    }
  };

  const formattedStartDate = formatDate(startDate);
  const formattedEndDate = formatDate(endDate);
  const dateRange =
    formattedStartDate && formattedEndDate
      ? `${formattedStartDate} - ${formattedEndDate}`
      : '';

  // Create email subject with trip name
  const emailSubject = tripName
    ? `${t('trip:inquiryFor', 'Inquiry for')} ${tripName}`
    : '';
  const contactLink = getOperatorContactLink(operatorContact, emailSubject);

  return (
    <Box className='booking-empty-state'>
      <XGModal
        allowClosing={true}
        dismissable={false}
        id='booking-empty-state-modal'
        open={isOpenModal}
        maxWidth='md'
        scroll='paper'
        onClose={() => {
          if (updateIsOpen) {
            updateIsOpen(false);
          }
        }}
      >
        <Box className='booking-empty-state__container'>
          {/* Trip Header Section */}
          <Box className='booking-empty-state__header'>
            {tripImage && (
              <Box className='booking-empty-state__image'>
                <img
                  src={tripImage}
                  alt={tripName}
                  className='booking-empty-state__image-img'
                />
              </Box>
            )}

            <Box className='booking-empty-state__trip-info'>
              {tripName && (
                <h2 className='booking-empty-state__trip-title'>{tripName}</h2>
              )}

              {dateRange && (
                <p className='booking-empty-state__trip-dates'>{dateRange}</p>
              )}
            </Box>
          </Box>

          {/* Empty State Message */}
          <Box className='booking-empty-state__message-section'>
            <Typography
              variant='body1'
              className='booking-empty-state__message'
            >
              {t(
                'bookings:nothingAvailable',
                'Looks like nothing is available at this time.'
              )}
            </Typography>

            {contactLink && (
              <Typography
                variant='body2'
                className='booking-empty-state__contact'
              >
                {t('bookings:bookingHelpContact', 'For booking help, contact')}{' '}
                <a
                  href={contactLink.href}
                  className='booking-empty-state__email'
                >
                  {contactLink.label}
                </a>
              </Typography>
            )}
          </Box>
        </Box>
      </XGModal>
    </Box>
  );
};

export default BookingEmptyState;
